module.exports = __webpack_public_path__ + "static/media/groupMananjary.3398b2ca.jpg";